import { matchSorter } from "match-sorter";
import { Adapter } from "@/adapters/Adapter";
export class MatchSorterAdapter extends Adapter {
    constructor() {
        super(...arguments);
        this.name = "match-sorter";
    }
    initScorer() {
        return this.scorer = {
            search: (query) => matchSorter(this.items, query, this.options)
        };
    }
    convertResults(results) {
        const scores = {};
        const matches = {};
        // MatchSorter doesn't tell you which key scored highest, so just
        // default it to the first key
        const [scoreKey] = this.keys;
        // MatchSorter doesn't return any scores or matches, so just use
        // 0/empty defaults
        this.keys.forEach(key => {
            scores[key] = 0;
            matches[key] = [];
        });
        return results.map(item => ({
            item,
            score: 0,
            scoreKey,
            scoreValue: String(item[scoreKey]),
            scores,
            matches
        }));
    }
}
